import React from "react"
import { DraggableProvidedDragHandleProps } from "react-beautiful-dnd"
import { injectIntl } from "react-intl"
import { connect, ConnectedProps } from "react-redux"
import Checkbox from "../../common/checkbox/checkbox.component"
import Icon from "../../common/icon/icon.component"
import Image from "../../common/image/image.component.jsx"
import { DOCUMENT_TYPE } from "../../state/Constants"
import IntlProps from "../../state/helpers/IntlProps"
import { addPricingTableSelectedItem, patchPricingTableItem, removePricingTableSelectedItem } from "../../state/pricing/actions"
import Item from "../../state/pricing/Item"
import { getPricingTableItem } from "../../state/pricing/selectors"
import { PRICING_TABLE } from "../../utils/pricing/constants"

type OwnProps = {
    itemId: string
    mainObjectId: string
    type: DOCUMENT_TYPE
    sortable: boolean
    allowEdit: boolean
    dragHandle: DraggableProvidedDragHandleProps
    intl: IntlProps
    isRowSelected: (id: string) => boolean
}

const ImagePanelComponent = (props: Props) => {

    const itemObject = props.item ? new Item(props.item.attributes.itemObject) : undefined
    const handleNoClick = (e) => {
        e.preventDefault()
    }

    const ProductImage = (): JSX.Element => {
        let image = <Icon value={"image"} style={{ fontSize: "30px", overflow: "hidden", width: "50px", marginTop: "-5px" }} />
        if (itemObject && itemObject.hasAtLeastOneImage()) {
            image = <Image imageId={itemObject?.getImages()[0].id} size="very-small" imageClassName="overflow-hidden" className="mt-1" />
        }
        return image
    }

    return (
        <>
            <div className="d-flex">
                {props.allowEdit &&
                    
                    <Checkbox className={"mr-3"} checked={props.isRowSelected(props.item?.id ?? "")}
                        onChange={(isChecked) => {
                            if (isChecked) {
                                props.addPricingTableSelectedItem(props.item?.id ?? "", props.mainObjectId)
                            } else {
                                props.removePricingTableSelectedItem(props.item?.id ?? "", props.mainObjectId)
                            }
                        }} />
                }
                {(props.allowEdit || props.type !== PRICING_TABLE) &&
                    <span className={"mr-3 " + (props.allowEdit || props.sortable ? "" : "d-none")}>
                        <a href={"#"} className={"sort-handle"} onClick={handleNoClick} {...props.dragHandle}>
                            <Icon className={"lead"} value={"bars"} />
                        </a>
                    </span>
                }
                <ProductImage />
            </div>
        </>
    )
}

const mapState = (state, props: OwnProps) => {
    const id = props.itemId
    const objectId = props.mainObjectId
    const item = getPricingTableItem(state, id, objectId)
    return {
        ...props,
        item: item,
    }
}
const mapDispatch = { patchPricingTableItem, addPricingTableSelectedItem, removePricingTableSelectedItem }
const connector = connect(mapState, mapDispatch)
type Props = ConnectedProps<typeof connector>
export default connector(injectIntl(ImagePanelComponent))


// WEBPACK FOOTER //
// ./src/pricing/components/ImagePanelComponent.tsx